<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" title="Guardar" (click)="saveProducto()" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>
    
    <app-especie-eppo-popup (selected)="onAcceptDialogEspecieEppo($event)" [esExportacion]="true"></app-especie-eppo-popup>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Producto {{codigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloEstadoSolicitudEx}}" />
                <img *ngIf="IdSubTipoSolicitudEx === tercerPaisConAtestFito || IdSubTipoSolicitudEx === reExpConAtestFito || IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--DATOS BASICOS -->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosBasicos = !isCollapsedDatosBasicos" [attr.aria-expanded]="!isCollapsedDatosBasicos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos básicos
                                    <i *ngIf="isCollapsedDatosBasicos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosBasicos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosBasicos" [ngbCollapse]="isCollapsedDatosBasicos">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Grupo</label>
                                            <ng-select [items]="listGrupo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdGrupo"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listGrupo || listGrupo.length === 0"
                                                       [loading]="!listGrupo || listGrupo.length === 0"
                                                       notFoundText="Grupo no encontrado"
                                                       placeholder="-- Seleccione un Grupo --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdGrupo')"
                                                       (change)="onSelectGrupo()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGrupo','required')">
                                                Grupo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Forma</label>
                                            <ng-select [items]="listForma"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdForma"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listForma || listForma.length === 0"
                                                       [loading]="(!listForma || listForma.length === 0) && (form.value.IdGrupo > 0)"
                                                       notFoundText="Forma no encontrada"
                                                       placeholder="-- Seleccione una Forma --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdForma')"
                                                       (change)="onSelectForma()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdForma','required')">
                                                Forma es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">País Origen</label>

                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPais"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listPais || listPais.length === 0"
                                                       [loading]="!listPais || listPais.length === 0"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPais')"
                                                       (change)="onSelectPais()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                                País Origen es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : provinciaObligatoria }" for="intEstado">Provincia</label>

                                            <ng-select [items]="listProvincia"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdProvincia"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listProvincia || listProvincia.length === 0"
                                                       [loading]="(!listProvincia || listProvincia.length === 0) && (form.value.IdPais > 0) && (form.value.IdPais === 60)"
                                                       notFoundText="Provincia no encontrada"
                                                       placeholder="-- Seleccione una Provincia --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdProvincia')">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                                Provincia es obligatoria
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">
                                        
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">C. Taric (Partida Arancelaria)</label>
                                            <input formControlName="CodigoTaric" numbersOnly name="CodigoTaric" [ngClass]="displayFieldCss('CodigoTaric')" title=""
                                                   class="form-control" id="inpNombre" type="text" value="" maxlength="10"><!--maxlength="10"-->

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','required')">
                                                Código Taric es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','maxlength')">
                                                El Código Taric debe tener 10 caracteres
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoTaric','minlength')">
                                                El Código Taric debe tener 10 caracteres
                                            </div>
                                        </div>
                                        

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : eppoObligatorio }" for="inpDescripcion">Código Eppo</label>
                                            <div class="input-group">
                                                <input readonly formControlName="CodigoEppo" name="CodigoEppo" title="" class="form-control" [ngClass]="displayFieldCss('CodigoEppo')" id="" type="text" value="">
                                                <span class="input-group-btn">
                                                    &nbsp;<button [disabled]="!habilitarBusquedaEppo" name="btnSearchCodigoEppo" class="btn btn-list btn-secondary" type="button" title="Buscar Código Eppo" (click)="onSearchCodigoEppo()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoEppo','required')">
                                                Código Eppo es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nombre Botánico</label>
                                            <input readonly formControlName="NombreBotanico" [ngClass]="displayFieldCss('NombreBotanico')" name="NombreBotanico" title="" class="form-control" id="inpNRegistro" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreBotanico','required')">
                                                Nombre Botánico es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nombre Común</label>
                                            <input formControlName="NombreComun" name="NombreComun" [ngClass]="displayFieldCss('NombreComun')" maxlength="100" title="" class="form-control" id="inpNombre" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreComun','required')">
                                                Nombre Común es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row"> 

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpDescripcion">Peso Neto (Kg)</label>
                                            <input formControlName="Peso" [decimalsOnly]="5" name="Peso" [ngClass]="displayFieldCss('Peso')"
                                                   maxlength="19" title="" class="form-control" id="peso" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Peso','required')">
                                                Peso es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Peso','DecimalTopCero')">
                                                Peso debe ser mayor que cero
                                            </div>
                                            <div class="invalid-feedback" *ngIf="isFieldInvalid('Peso', 'PesoFormatoValido')">
                                                El peso debe tener como máximo 13 dígitos enteros y 5 decimales.
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpDescripcion">Volumen (m³)</label>
                                            <input formControlName="Volumen" [decimalsOnly]="3" name="Volumen" maxlength="15" title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpDescripcion">Unidades</label>
                                            <input formControlName="Unidades" numbersOnly name="Unidades" maxlength="10" title="" class="form-control" id="" type="text" value="">
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--BULTO-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedBulto = !isCollapsedBulto" [attr.aria-expanded]="!isCollapsedBulto" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i>
                                    Bulto
                                    <i *ngIf="isCollapsedBulto" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedBulto" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedBulto" [ngbCollapse]="isCollapsedBulto">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoBultosObligatorio }" for="inpDescripcion">Marcas bulto</label>
                                            <input formControlName="MarcasBulto" name="MarcasBulto" maxlength="100" title="" [ngClass]="displayFieldCssNoSubmit('MarcasBulto')" (change)="onChangeMarcasBulto()" class="form-control" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('MarcasBulto','required')">
                                                Marcas Bultos es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoBultosObligatorio }" for="inpDescripcion">Nº de bultos</label>
                                            <input formControlName="NumeroBulto" numbersOnly name="NumeroBulto" maxlength="10" title="" [ngClass]="displayFieldCssNoSubmit('NumeroBulto')" (change)="onChangeNumeroBulto()" class="form-control" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('NumeroBulto','required')">
                                                Nº Bultos es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoBultosObligatorio }" for="intEstado">Tipo Bulto</label>
                                            <ng-select [items]="listBulto"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipoBulto"
                                                       loadingText="Cargando..."
                                                       [readonly]="!listBulto || listBulto.length === 0"
                                                       [loading]="!listBulto || listBulto.length === 0"
                                                       notFoundText="Tipo no encontrado"
                                                       placeholder="-- Seleccione un Tipo --"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectTipoBulto()"
                                                       [ngClass]="displayFieldCssNgSelectNoSubmit('IdTipoBulto')">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('IdTipoBulto','required')">
                                                Tipo Bulto es obligatorio
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
